import React from 'react'
import PropTypes from 'prop-types'
import PrivateWealthEmailLink from 'components/Shared/PrivateWealthEmailLink/PrivateWealthEmailLink'
import { FullscreenModal } from 'belle-js'
import connectModal from 'connectModal'
import modalStyles from '../Modals.module.scss'


const BeneficiaryInfoModal = (props) => {
  const {
    isOpen,
    closeModal,
    isActiveModal,
  } = props

  return (
    <FullscreenModal
      isOpen={isOpen}
      isActiveModal={isActiveModal}
      className={modalStyles.Modal}
      onClose={closeModal}
      testId="beneficiaryInfoModal">
      <h2>
        What is a beneficiary?
      </h2>

      <p>
        The person or people designated as beneficiary will receive payment of
        the account value of this IRA upon your death.
      </p>

      <p>Things to consider:</p>

      <ul>
        <li>
          If you designate more than one primary beneficiary,
          the share percentages must total 100%, per beneficiary type
        </li>
        <li>
          If you with to designate a trust as a beneficiary, please
          contact <PrivateWealthEmailLink />,
          and we will assist you.
        </li>
        <li>
          If your primary beneficiary does not survive you,
          your IRA balance will be distributed to your
          contingent beneficiary(ies) upon your death
        </li>
      </ul>

      <div className={modalStyles.actions}>
        <button
          type="button"
          className="button button--primary"
          onClick={closeModal}>
          Got it!
        </button>
      </div>
    </FullscreenModal>
  )
}

BeneficiaryInfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  isActiveModal: PropTypes.bool.isRequired
}


export default connectModal(BeneficiaryInfoModal, 'beneficiaryInfoModal')



// WEBPACK FOOTER //
// ./src/components/Onboarding/Modals/BeneficiaryInfoModal/BeneficiaryInfoModal.jsx